module.exports = __webpack_public_path__ + "fonts/icomoon.d6597c9.woff";